export default function TrainingStats() {
  const stats = [
    { icon: 'ri-user-star-fill', value: '50+', label: 'Professional Coaches' },
    { icon: 'ri-team-fill', value: '2,500+', label: 'Students Trained' },
    { icon: 'ri-trophy-fill', value: '85%', label: 'Tournament Win Rate' },
    { icon: 'ri-time-fill', value: '10,000+', label: 'Training Hours' }
  ];

  return (
    <section className="py-16 px-6 bg-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-white text-2xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-white mb-2">{stat.value}</div>
              <div className="text-gray-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
